import { useContext, useEffect, useReducer, useState } from "react"
import { LineaCarga } from "../../components/LineaCarga"
import { MultiSelectorFecha } from "../../components/pickers/MultiSelectorFecha"
import { ContenedorParametros } from "../../components/utils/ContenedorParametros"
import { agregarDias, convertirSegundosAFormatoHr, formatDate } from "../../../utils/utils"
import { BotonProcesar } from "../../components/buttons/BotonProcesar"
import { ContenedorTabla } from "../../components/utils/ContenedorTabla"
import { useIncidencias } from "../../../hooks/incidencias/useIncidencias"
import { Modal } from "../../components/modal/Modal"
import { useModal } from "../../../hooks/useModal"
import { MultiSelect } from "../../components/forms/MultiSelect"
import { useUsuarios } from "../../../hooks/usuarios/useUsuarios"
import { UserContext } from "../../../context/provider/UserProvider"
import { ModalProyecto } from "../../components/modal/ModalProyecto"
import { ContenedorImagen } from "../../components/ContenedorImagen"
import { useEmpresas } from "../../../hooks/useEmpresas"
import { Tooltip } from "../../components/utils/Tooltip"
import { ExportExcel } from "../../components/utils/ExportExcel"

const imagenReducer = (estado, accion) => {
    switch(accion.tipo){
        case 'Agregar':
            return [...estado, ...accion.carga];
        case 'Remover':
            return estado.filter(file => file?.codigo ? 
                (file.codigo !== accion.carga.codigo) : (file.identificador !== accion.carga.identificador)
            );
        case 'Reiniciar':
            return []
        case 'Cargar':
            return accion.carga
        default:
            return estado;
    }
}

const docReducer = (estado, accion) => {
    switch(accion.tipo){
        case 'Agregar':
            return [...estado, ...accion.carga];
        case 'Remover':
            return estado.filter(file => file?.codigo ? 
                (file.codigo !== accion.carga.codigo) : (file.identificador !== accion.carga.identificador)
            );
        case 'Reiniciar':
            return []
        case 'Cargar':
            return accion.carga
        default:
            return estado;
    }
}

export const Incidencias = () => {
    const { stateUser } = useContext(UserContext);
    const [ startDate, setStartDate ] = useState(agregarDias(-30));
    const [ endDate, setEndDate ] = useState(formatDate(new Date()));
    const [ codigoEstado, setCodigoEstado ] = useState(48);
    const [ codigoIncidencia, setCodigoIncidencia ] = useState(0);
    const [ usuariosConcat, setUsuariosConcat ] = useState('');
    const [ isOpenModalAsignar, openModalAsignar, closeModalAsignar ] = useModal(null);
    const [ isOpenModalDetalle, openModalDetalle, closeModalDetalle ] = useModal(null);
    const [ isOpenModalSolucion, openModalSolucion, closeModalSolucion ] = useModal(null);
    const [ imagenes, envioImagen ] = useReducer(imagenReducer, []);
    const [ imagenesExtra, envioImagenExtra ] = useReducer(imagenReducer, []);
    const [ codigoEmpresa, setCodigoEmpresa ] = useState(0);
    const [ codigoParticipante, setCodigoParticipante ] = useState('');
    const [ codigoUrgencia, setCodigoUrgencia ] = useState(0);
    const [ imagenesSolucion, envioImagenesSolucion ] = useReducer(imagenReducer, []);  
    const [ codEstadoElegido, setCodEstadoElegido ] = useState(0);
    const [ isOpenModalDetalleSeguimiento, openModalDetalleSeguimiento, closeModalDetalleSeguimiento ] = useModal(null);
    const [ esCrearSeguimiento, setEsCrearSeguimiento ] = useState(false);
    const [ valoresSeguimiento, setValoresSeguimiento ] = useState({indice: 0, codIncidencia: 0})

    const classNameInput = "py-1 px-2 caret-white containerScroll text-white rounded  bg-zinc-900 text-l focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:opacity-70 disabled:cursor-not-allowed";
    const classNameSelect = "py-1 px-2 containerScroll text-white  rounded bg-zinc-900 text-l focus:outline-none focus:ring-1 focus:ring-blue-500 lg:text-xs ";
    const idTablaIncidencias = 'idTablaIncidencias';
    const estadosIncidencia = [
        { codEstado: 48, nomEstado: "En Proceso", abrevEstado: "PROC"},
        { codEstado: 59, nomEstado: "Solucionado", abrevEstado: "SOL"},
        { codEstado: 7, nomEstado: "Cerrado", abrevEstado: "CERR"},
    ];
    
    const {
        listarIncidencias,
        incidencias,
        editarValorParticipantes,
        guardarParticipantes,
        editarValorSolucion,
        solucion,
        guardarSolucion,

        listarDetalleIncidencia,
        detalleIncidencia,
        imagenesDetalle,
        datosValidacion,
        imagenesValidacion,
        documentosValidacion,
        listarTipoUrgencia,
        tipoUrgencia,
        listarConceptosIncidencia,
        conceptosIncidencia,
        resolucion,
        loading,
        listarSeguimientoTicketIncidencia,
        seguimientosIncidencia,
        editarValorNuevoSeguimientoIncidencia,
        editarValorSeguimientoIncidencia,
        registrarSeguimientoIncidencia,
        eliminarSeguimientoIncidencia,
        nuevoSeguimientoIncidencia,
    } = useIncidencias();

    const {
        listarUsuarios,
        usuarios,
    } = useUsuarios();
    
    const {listarEmpresas, empresas} = useEmpresas()

    useEffect(()=> {
        listarEmpresas();
        listarTipoUrgencia();
        listarUsuarios(stateUser.codAreaActual);
    },[])
    
    useEffect(() => {
        listarIncidencias(startDate, endDate, codigoEstado,  codigoParticipante, codigoUrgencia, codigoEmpresa)
    },[startDate, endDate, codigoEstado, codigoParticipante, codigoUrgencia, codigoEmpresa])
    
    const labelEstado = (codEstado, nomEstado) => {
        let color = 'bg-gray-500';

        switch(codEstado){
            case 40: color = 'bg-yellow-600';
            break;
            case 48: color = 'bg-green-600';
            break;
            case 59: color = 'bg-red-600';
            break;
            default: color = 'bg-gray-600';
            break;
        }

        return(
            <span className={`${color} relative px-2 text-xs rounded`}>{nomEstado}</span>
        )
    }

    const usuariosConvertidos = usuarios.map(option => ({
        value: option.nomUsuario.split('@')[0],
        label: option.nomUsuario
    }));

    const guardarAsignarParticipantes = async () => {
        const isValid = await guardarParticipantes(codigoIncidencia);
        if(isValid){
            await listarIncidencias(startDate, endDate, codigoEstado, codigoParticipante, codigoUrgencia, codigoEmpresa)
            closeModalAsignar()
        }
    }

    const registrarSolucion = async () => {
        const isValid = await guardarParticipantes(codigoIncidencia);
        if(isValid){
            const isValidSolucion = await guardarSolucion(codigoIncidencia);
            if(isValidSolucion){
                await listarIncidencias(startDate, endDate, codigoEstado, codigoParticipante, codigoUrgencia, codigoEmpresa);
                closeModalSolucion();
                closeModalDetalle();
                setUsuariosConcat('');
            }
        }
    }

    const cerrarModalParticipantes = () => {
        setUsuariosConcat('')
        closeModalAsignar()
    }
    
    const parseURLArchivo = async (archivos) => {
        return archivos.map(option => {
            const nuevoObjeto = {};
            Object.keys(option).forEach(key => {
                if(key === 'codIncidenciaArchivo'){
                    nuevoObjeto.codigo = option[key];
                }
                else
                    if(key.startsWith('nom')){
                        nuevoObjeto.nom = option[key];
                    }
                    else
                        if(key.startsWith('url')){
                            nuevoObjeto.url = option[key];
                        }
            });
            return nuevoObjeto;
        })
    }

    const registrarSeguimientoTicketIncidencia = async (indice) => {
        const isValid = await registrarSeguimientoIncidencia(indice);
        if(isValid){
            editarValorNuevoSeguimientoIncidencia('descripcion','')
            await listarSeguimientoTicketIncidencia(valoresSeguimiento.codIncidencia)
            await listarIncidencias(startDate, endDate, codigoEstado,  codigoParticipante, codigoUrgencia, codigoEmpresa)
        }
    }

    useEffect(() => {
        const asincronaImg = async (imagenes,envioImagen) => {
            const urlImagen = await parseURLArchivo(imagenes);
            envioImagen({ tipo: 'Cargar', carga: urlImagen});
        }
        imagenesDetalle.length > 0 ? asincronaImg(imagenesDetalle,envioImagen) : envioImagen({tipo: 'Reiniciar'});
        imagenesValidacion.length > 0 ? asincronaImg(imagenesValidacion,envioImagenExtra) : envioImagenExtra({tipo: 'Reiniciar'});
    },[imagenesDetalle, imagenesValidacion])


    return(
        <>
            {loading && <LineaCarga/>}
            <ContenedorParametros titulo='Atención de incidencias derivadas' tablaId={idTablaIncidencias}>
                <MultiSelectorFecha
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    identificador='gestionProyecto'
                />
                <section className="flex gap-2 items-center">
                    <i className="fa fa-filter" title="Estado"></i>
                    <select className={`${classNameSelect}`} value={codigoEstado}  onChange={(e)=> setCodigoEstado(Number(e.target.value))}>
                        <option key={'option_0'} value={0}>--Todos--</option>
                        {
                            estadosIncidencia.map((es,i) => (
                                <option key={'option_'+(i + 1)} value={es.codEstado}>{es.nomEstado}</option>
                            ))
                        }
                    </select>
                </section>
                <section className="flex gap-2 items-center">
                    <i className="fa fa-building" title="Empresa"></i>
                    <select className={`${classNameSelect}`} onChange={(e)=> setCodigoEmpresa(e.target.value)}>
                        {
                            <option value={0}>--Todos--</option>
                        }
                        {
                            empresas.length > 0 ? 
                                empresas.map((emp) => (
                                    <option value={emp.codEmpresa}>{emp.nomEmpresa}</option>
                                ))
                            : <></>

                        }
                    </select>
                </section>
                <section className="flex gap-2 items-center">
                    <i className="fa fa-user" title="Participante"></i>
                    <select className={`${classNameSelect}`} onChange={(e)=> setCodigoParticipante(e.target.value)}>
                        {<option value={''}>--Todos--</option>}
                        {
                            usuarios.length > 0 ? 
                                usuarios.map(usu => (
                                    <option value={usu.nomUsuario.split('@')[0]}>{usu.nomUsuario.split('@')[0]}</option>
                                ))
                            :
                                <></>
                        }
                    </select>
                </section>
                <section className="flex gap-2 items-center">
                    <i className="fa fa-ellipsis-v" title="Urgencia"></i>
                    <select className={`${classNameSelect}`} onChange={(e)=> setCodigoUrgencia(e.target.value)}>
                        {<option value={0}>--Todos--</option>}
                        {
                            tipoUrgencia.length > 0 ? 
                                tipoUrgencia.map(urg => (
                                    <option value={urg.codUrgencia}>{urg.nomUrgencia}</option>
                                ))
                            :
                                <></>
                        }
                    </select>
                </section>

                <BotonProcesar onClick={async () => listarIncidencias(startDate, endDate, codigoEstado, codigoParticipante, codigoUrgencia, codigoEmpresa)}/>
                    
                <img src="https://img.icons8.com/?size=96&id=UECmBSgBOvPT&format=png" className="w-[40px] h-[40px] cursor-pointer" onClick={() => ExportExcel(["tablaOcultaIncidenciasTotales"],'Atencion de incidencias','Reporte de atencion de incidencias')}></img>
            </ContenedorParametros>
            <ContenedorTabla>
                <table
                    id={idTablaIncidencias}
                    className="tableResponsive"
                    // ref={tablaProyectoRef}
                >
                    <thead>
                        <tr key={'trCabecera'} className="uppercase">
                            <th className="w-[50px]">N°</th>
                            <th className="w-[100px]">Ticket</th>
                            <th className="w-[200px]">Fecha derivación</th>
                            { codigoEstado !== 48 && <th className="w-[200px]">Fecha solución</th>}
                            <th className="w-[350px] text-left">Nombre</th>
                            <th className="w-[300px] text-left">Empresa</th>
                            <th className="w-[150px] text-left">Participantes</th>
                            <th className="w-[100px] text-left">Prioridad</th>
                            <th className="w-[150px]">Estado</th>
                            <th className="w-[50px]">SEGUIMIENTO</th>
                            <th className="w-[50px]"></th>
                            <th className="w-[50px]"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            incidencias.length > 0 ?
                                incidencias.map((inc, i) => (
                                    <tr key={'tr_body_' + i}>
                                        <td className="text-center">{i + 1}</td>
                                        <td
                                            className="items-center flex justify-center"
                                            // onClick={async () => {
                                            //     await listarDetalleIncidencia(inc.codIncidencia);
                                            //     await listarConceptosIncidencia(inc.codProductoInterno)
                                            //     openModalDetalle();
                                            // }}
                                        >
                                            <span className="px-2 text-center w-[60px] relative block rounded bg-blue-600">{inc.codIncidencia}</span>
                                        </td>
                                        <td className="text-center w-[200px]">{inc.fechaHoraRegistroDerivacion}</td>
                                        {
                                            codigoEstado !== 48 && <td className="text-center w-[200px]">{inc.fechaHoraRegistroSolucion}</td>
                                        }
                                        
                                        <td className="">
                                            <div className="w-[340px] whitespace-nowrap text-ellipsis overflow-hidden">{inc.tituloIncidencia}</div>
                                        </td>
                                        <td className="">{inc.nomEmpresa}</td>
                                        <td className="w-[150px]">
                                            <div className="w-[140px] whitespace-nowrap text-ellipsis overflow-hidden">{inc.uidSolucionConcatenado}</div>
                                        </td>
                                        <td className="text-left">
                                            <i
                                                className={`fa fa-circle ${inc.codUrgencia == 1 ? ' text-red-600 ' : 
                                                (inc.codUrgencia == 2 ? ' text-orange-500 ' : ' text-yellow-500 ')}`}
                                            ></i>
                                            <span className="px-2">{inc.nomUrgencia}</span>
                                        </td>
                                        <td className="text-center w-[150px]">{labelEstado(inc.codEstado,inc.nomEstado)}</td>
                                        <td data-label="SEGUIMIENTO:" className=''>
                                            <section className='flex items-center gap-x-2 lg:justify-end'>
                                                {
                                                    inc.codEstado === 51 ? '' : 
                                                        <>
                                                            <button
                                                                key={'agregarSeguimiento_0'+inc.codIncidencia}
                                                                className='bg-green-500  px-1 rounded hover:shadow-inner'
                                                                data-tip={'addFollow'}
                                                                data-for={'addFollow'}
                                                                onClick={async () => {
                                                                    !esCrearSeguimiento && setEsCrearSeguimiento(true)
                                                                    editarValorNuevoSeguimientoIncidencia('descripcion','')
                                                                    editarValorNuevoSeguimientoIncidencia('codIncidencia',inc.codIncidencia)
                                                                    setValoresSeguimiento({indice: 0, codIncidencia: inc.codIncidencia})
                                                                    await listarSeguimientoTicketIncidencia(inc.codIncidencia)
                                                                    await openModalDetalleSeguimiento()
                                                                }}
                                                            >
                                                                <i className=' fa fa-plus'></i>
                                                            </button>
                                                            {/* <Tooltip id={'addFollow'} key={'tool_t' + inc.codIncidencia}>Agregar seguimiento</Tooltip> */}
                                                        </>
                        
                                                }
                                                {
                                                    inc.seguimientoIncidencia.length > 0 ?
                                                        <section
                                                            key={inc.codIncidencia + '_' + inc.nomIncidenciaConcepto}
                                                            className='w-[90%] flex overflow-x-auto containerScroll lg:w-auto'
                                                        >
                                                            {
                                                                inc.seguimientoIncidencia.map((det, i) => (
                                                                    <>
                                                                        <button
                                                                            key={i + '_' + det.nomSeguimiento}
                                                                            data-tip={det.codSeguimiento + '_'}
                                                                            data-for={det.codSeguimiento + '_'}
                                                                            className={`px-2 bg-blue-500 border border-blue-900 rounded`}
                                                                            title={det.nomSeguimiento}
                                                                            onClick={async () => {
                                                                                esCrearSeguimiento && setEsCrearSeguimiento(false)
                                                                                await listarSeguimientoTicketIncidencia(inc.codIncidencia);
                                                                                setValoresSeguimiento({indice: i + 1, codIncidencia: inc.codIncidencia})
                                                                                await openModalDetalleSeguimiento()
                                                                            }}
                                                                        >{i + 1}</button>
                                                                        {/* <Tooltip
                                                                            id={det.codSeguimiento + '_'}
                                                                        >{det.nomSeguimiento}</Tooltip> */}
                                                                    </>
                                                                ))
                                                            }
                                                        </section>
                                                    : <></>
                                                }
                                            </section>
                                            
                                        </td>
                                        <td className="text-center">
                                            <img
                                                title="Ver detalle"
                                                src="https://img.icons8.com/?size=48&id=dslcyJwWWDHs&format=png"
                                                alt=""
                                                className="w-[30px] h-[30px]"
                                                onClick={async () => {
                                                    await setCodEstadoElegido(inc.codEstado)
                                                    await setCodigoIncidencia(inc.codIncidencia);
                                                    await listarDetalleIncidencia(inc.codIncidencia);
                                                    await listarConceptosIncidencia(inc.codProductoInterno)
                                                    await openModalDetalle()
                                                }}
                                            ></img>
                                        </td>
                                        <td className="text-center w-[50px]">
                                            {
                                                inc.codEstado !== 59 && inc.codEstado !== 7 ?
                                                    <button
                                                        className="bg-blue-500 px-2 rounded"
                                                        onClick={async ()=>{
                                                            await setCodigoIncidencia(inc.codIncidencia);
                                                            await setUsuariosConcat(inc.uidSolucionConcatenado)
                                                            await openModalAsignar();
                                                        }}
                                                    >
                                                        <i className="fa fa-user-plus"></i>
                                                    </button>
                                                :
                                                    <></>
                                            }
                                        </td>
                                    </tr>
                                ))
                            :
                                <tr><td colSpan={11} className="text-center">No hay información para mostrar...</td></tr>
                        }
                    </tbody>
                </table>
                <table className="hidden" id="tablaOcultaIncidenciasTotales">
                    <thead>
                        <tr>
                            <th>N°</th>
                            <th>Ticket</th>
                            <th>Fecha derivación</th>
                            { codigoEstado !== 48 && <th >Fecha solución</th>}
                            <th>Nombre</th>
                            <th>Empresa</th>
                            <th>Participantes</th>
                            <th>Prioridad</th>
                            <th>Estado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            incidencias.length > 0
                            ?   incidencias.map((inc, i) => (
                                    <tr key={i+1}>
                                        <td>{i + 1}</td>
                                        <td>{inc.codIncidencia}</td>
                                        <td>{inc.fechaHoraRegistroDerivacion}</td>
                                        {
                                            codigoEstado !== 48 && <td>{inc.fechaHoraRegistroSolucion}</td>
                                        }
                                        <td>{inc.tituloIncidencia}</td>
                                        <td>{inc.nomEmpresa}</td>
                                        <td>{inc.uidSolucionConcatenado}</td>
                                        <td>{inc.nomUrgencia}</td>
                                        <td>{inc.nomEstado}</td>
                                    </tr>
                                ))
                            :   <tr><td colSpan={9} className="text-center">No hay información para mostrar...</td></tr>
                        }
                    </tbody>
                </table>
            </ContenedorTabla>
            
            <Modal
                isOpen={isOpenModalAsignar}
                title={'Asignar participantes'}
                action={() => guardarAsignarParticipantes()}
                closeModal={cerrarModalParticipantes}
            >
                <section className="w-[600px]">
                    <span>Usuarios</span>
                    <MultiSelect
                        search={true}
                        data={usuariosConvertidos}
                        setEdit ={editarValorParticipantes}
                        keyEdit={'codUsuarioParticipanteConcatenado'}
                        width={'w-auto'}
                        defaultValue={usuariosConcat}
                        isBlocket={false}
                    />
                </section>
            </Modal>

            <Modal
                isOpen={isOpenModalDetalle}
                closeModal={closeModalDetalle}
                textButtons={{other: 'Solucionar',confirm: 'Validar', denied: 'Cerrar'}}
                validButton={{
                    other: (resolucion.uidSolucionConcatenado === '' && codEstadoElegido === 48 ? true : false),
                    confirm: (codEstadoElegido === 59 ? true : false),
                    denied: true
                }}
                title={`[ ${codigoIncidencia} ] ${detalleIncidencia.tituloIncidencia}`}
                clasesModal="h-[800px] w-[1000px]"
                action={() => console.log('aca va la accion de guardar validacion')}
                actionOtherButton={async() => {
                    editarValorParticipantes('codUsuarioParticipanteConcatenado',stateUser.nomUsuario.split('@')[0]);
                    editarValorSolucion('causaIncidencia', '');
                    editarValorSolucion('comentarioSolucion', '');
                    await envioImagenesSolucion({tipo: 'Reiniciar'})
                    openModalSolucion()
                }}
            >
                <section className="overflow-y-auto containerScroll h-full">
                    <fieldset className="border border-zinc-600 m-2 rounded px-2">
                        <legend className="px-2">Detalle incidencia</legend>
                        <section className="grid grid-cols-[minmax(0,13fr)_minmax(0,37fr)_minmax(0,13fr)_minmax(0,37fr)] gap-y-1 gap-x-2 p-2">
                            {
                                <div className="col-span-2 grid grid-cols-[minmax(0,27fr)_minmax(0,23fr)_minmax(0,13fr)_minmax(0,37fr)] gap-x-2">
                                    <span className="self-center">Usuario registro</span>
                                    <input className={`${classNameInput} min-h-0 `} value={detalleIncidencia.uidCreacion} disabled/>
                                    <span className="self-center">Fecha</span>
                                    <input className={`${classNameInput} min-h-0 text-sm`} value={detalleIncidencia.fechaHoraCreacion} disabled/>
                                </div>
                            }
                            <span className="self-center">Empresa</span>
                            <input className={`${classNameInput} min-h-0 `} value={detalleIncidencia.nomEmpresa} disabled/>
                            <span className="self-center">Producto</span>
                            <input className={`${classNameInput} min-h-0 `} value={detalleIncidencia.nomProductoInterno} disabled/>
                            <span className="self-center">Concepto</span>
                            <select
                                className={`${classNameSelect} w-full`}
                                disabled={true}
                                value={datosValidacion.codIncidenciaConcepto}
                            >
                                {
                                    conceptosIncidencia.length > 0 &&
                                    conceptosIncidencia.map(data => (
                                        <option
                                            key={data.codIncidenciaConcepto + '_option'}
                                            value={data.codIncidenciaConcepto}
                                        >{data.nomIncidenciaConcepto}</option>
                                    ))
                                }
                            </select>
                            <span className="self-center">Descripción</span>
                            <textarea className={`${classNameInput}`} value={detalleIncidencia.descripcionIncidencia} disabled/>
                            <span className="self-center">Imagen</span>
                            <section className={`${imagenesDetalle.length > 0 ? ' h-[130px]' : ' h-[80px] '} `}>
                                <ContenedorImagen archivo={imagenes} esBloqueo={true} envioImagen={envioImagen} showThumbs={false}/>
                            </section>
                        </section>
                    </fieldset>
                    <fieldset className="border border-zinc-600 m-2 rounded px-2">
                        <legend className="px-2">Detalle validación</legend>
                        <section className="grid grid-cols-[minmax(0,15fr)_minmax(0,35fr)_minmax(0,15fr)_minmax(0,35fr)] gap-y-1 gap-x-2 p-2">
                            <span className="self-center">Comentario</span>
                            <textarea className={`${classNameInput}`} value={datosValidacion.comentarioAtencion} disabled/>
                            <span className="self-center">Imagenes</span>
                            <section className={`${imagenesValidacion.length > 0 ? ' h-[130px]' : ' h-[80px] '} `}>
                                <ContenedorImagen archivo={imagenesExtra} esBloqueo={true} envioImagen={envioImagenExtra} showThumbs={false}/>
                            </section>
                            <span className="self-center">Documentos</span>
                            <div className="col-span-3">
                            {documentosValidacion?.length > 0 ? (
                                <ul className="space-y-2 max-h-[160px] overflow-y-auto containerScroll pr-1">
                                {documentosValidacion.map((doc) => (
                                    <li
                                    key={doc.codIncidenciaArchivo}
                                    className="flex items-center justify-between rounded border border-zinc-700 px-3 py-2 bg-zinc-900/50"
                                    >
                                    <div className="flex items-center gap-2 min-w-0">
                                        <i className="fa fa-file text-blue-400"></i>
                                        <span className="truncate" title={doc.nombreArchivo}>
                                        {doc.nombreArchivo || "Documento"}
                                        </span>
                                    </div>
                                    <div className="flex items-center gap-2 shrink-0">
                                        <a
                                        href={doc.urlArchivo}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-xs px-2 py-1 rounded bg-blue-600 hover:bg-blue-500"
                                        title="Abrir en nueva pestaña"
                                        >
                                        Descargar
                                        </a>
                                    </div>
                                    </li>
                                ))}
                                </ul>
                            ) : (
                                <span className="opacity-60 text-sm">— Sin documentos —</span>
                            )}
                            </div>
                            <span>Prioridad</span>
                            <select className={`${classNameInput} min-h-0 `} value={datosValidacion.codUrgencia} disabled>
                                {
                                    tipoUrgencia.length > 0 ? 
                                    tipoUrgencia.map(urg => (
                                        <option value={urg.codUrgencia}>{urg.nomUrgencia}</option>
                                    ))
                                    :   <option value={0}>--Sin opcion--</option>
                                }
                            </select>
                        </section>
                    </fieldset>
                    <fieldset className="border border-zinc-600 m-2 rounded px-2">
                        <legend className="px-2">Detalle solución</legend>
                        <section className="grid grid-cols-[minmax(0,15fr)_minmax(0,35fr)_minmax(0,15fr)_minmax(0,35fr)] gap-y-1 gap-x-2 p-2">
                            <span>Participantes</span>
                            {/* <ul className="list-disc ml-5">
                                {
                                    resolucion.uidSolucionConcatenado.split(',').map(uid => (
                                        <li className="">{uid}</li>
                                    ))
                                }
                            </ul> */}
                            <input className={`${classNameInput} min-h-0 `} value={resolucion.uidSolucionConcatenado} disabled/>
                            <span>Fecha atención</span>
                            <input className={`${classNameInput} min-h-0 `} value={resolucion.fechaHoraInicioAtencion} disabled/>
                            <span className="self-center">Causa</span>
                            <textarea className={`${classNameInput}`} value={resolucion.causaIncidencia} disabled/>
                            <span className="self-center">Solución</span>
                            <textarea className={`${classNameInput}`} value={resolucion.comentarioSolucion} disabled/>
                            <span>Tiempo total de atención</span>
                            <input className={`${classNameInput} min-h-0 `} value={convertirSegundosAFormatoHr(resolucion.segundosTotalAtencion)} disabled/>
                        </section>
                    </fieldset>
                </section>
            </Modal>

            <Modal
                isOpen={isOpenModalSolucion}
                closeModal={closeModalSolucion}
                action={()=> registrarSolucion()}
                title={`Solucionar ticket [ ${codigoIncidencia} ]`}
            >
                <section className="grid gap-y-1 w-[600px] ">
                    <span>Causa</span>
                    <textarea
                        className={`${classNameInput} h-[100px]`}
                        placeholder="Escribir la causa..."
                        value={solucion.causaIncidencia}
                        onChange={(e)=> editarValorSolucion('causaIncidencia', e.target.value)}
                    />
                    <span>Solución</span>
                    <textarea
                        className={`${classNameInput} h-[100px]`}
                        placeholder="Escribir la solución de la incidencia..."
                        value={solucion.comentarioSolucion}
                        onChange={(e)=> editarValorSolucion('comentarioSolucion', e.target.value)}
                    />
                    {/* <span>Categoría</span>
                    <select className={`${classNameSelect}`}></select>
                    <span>Imagenes</span>
                    <section className="h-[120px] w-[70%]">
                        <ContenedorImagen
                            envioImagen={envioImagenesSolucion}
                            archivo={imagenesSolucion}
                        ></ContenedorImagen>
                    </section> */}
                </section>
            </Modal>

            <Modal
                isOpen={isOpenModalDetalleSeguimiento}
                closeModal={closeModalDetalleSeguimiento}
                title={`Detalle seguimiento [ INCIDENCIA N°${valoresSeguimiento.codIncidencia} ]`}
                validButton={{confirm: false, denied: true}}
            >
                <div className='h-[400px] w-[900px] overflow-y-auto containerScroll lg:w-auto'>
                    <table className='tableResponsive'>
                        <thead>
                            <tr>
                                <th>N</th>
                                <th>COD</th>
                                <th>DESCRIPCIÓN</th>
                                <th className='whitespace-nowrap'>F. REGISTRO</th>
                                <th className='whitespace-nowrap'>U. REGISTRO</th>
                                <th></th>
                                {/* <th></th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                seguimientosIncidencia.length > 0 ? 
                                seguimientosIncidencia.map((det, i) => (
                                        <tr
                                            key={i + 1 }
                                            style={{background: valoresSeguimiento.indice === i + 1 ? '#19692a' : ''}}
                                        >
                                            <td>{i + 1}</td>
                                            <td><span className='bg-blue-500 px-2 rounded'>{det.codIncidenciaSeguimiento}</span></td>
                                            <td>
                                                <input
                                                    key={'input_'+i}
                                                    className={`${classNameInput} bg-transparent border-none px-2 !w-full`}
                                                    value={det.descripcion}
                                                    onChange={(e) => editarValorSeguimientoIncidencia(i,'descripcion',e.target.value)}
                                                    onKeyUp={(e)=> e.keyCode === 13 ? registrarSeguimientoTicketIncidencia(i) : ''}
                                                    enterKeyHint="enter"
                                                />
                                            </td>
                                            <td className='whitespace-nowrap text-center'>{det.fechaCreacion}</td>
                                            <td className='text-center'>{det.nomUsuarioCreacion}</td>
                                            <td className='text-center'>
                                                <i
                                                    className='fa fa-trash text-red-500'
                                                    onClick={async () => {
                                                        const isValid = await eliminarSeguimientoIncidencia(det.codIncidenciaSeguimiento)
                                                        if(isValid)
                                                        {
                                                            await listarSeguimientoTicketIncidencia(valoresSeguimiento.codIncidencia)
                                                            await listarIncidencias(startDate, endDate, codigoEstado,  codigoParticipante, codigoUrgencia, codigoEmpresa)
                                                        }
                                                    }}
                                                ></i>
                                            </td>
                                        </tr>
                                    )) 
                                : 
                                    (esCrearSeguimiento ? '':
                                        <tr>
                                            <td colSpan={6} className='text-center'>No hay información para mostrar...</td>
                                        </tr>
                                    )
                            }
                            {
                                esCrearSeguimiento ?
                                    <tr style={{background: valoresSeguimiento.indice === 0 ? '#19692a' : ''}} key={'tr_crear'}>
                                        <td colSpan={5} className='p-2'>
                                            <input
                                                className={`${classNameInput} px-2 w-full `}
                                                placeholder='Escribir aquí su seguimiento'
                                                onChange={(e )=> editarValorNuevoSeguimientoIncidencia('descripcion',e.target.value)}
                                                onKeyUp={(e)=> e.keyCode === 13 ? registrarSeguimientoTicketIncidencia() : ''}
                                                value={nuevoSeguimientoIncidencia.descripcion}
                                            />
                                        </td>
                                        <td>
                                            <button
                                                className='bg-blue-500 px-2 rounded'
                                                onClick={() => registrarSeguimientoTicketIncidencia()}
                                            >
                                                <i className='fa fa-paper-plane'></i>
                                            </button>
                                        </td>
                                    </tr>
                                : ''
                            }
                        </tbody>
                    </table>
                </div>
                <div className={` ${esCrearSeguimiento ? ' hidden ' : ' flex '} justify-end py-2`}>
                    <button
                        className=' rounded-[50%] bg-green-500 px-2 py-1'
                        onClick={()=> {
                            if(!esCrearSeguimiento){
                                editarValorNuevoSeguimientoIncidencia('descripcion','')
                                editarValorNuevoSeguimientoIncidencia('codIncidencia',valoresSeguimiento.codIncidencia)
                                setEsCrearSeguimiento(true)
                                setValoresSeguimiento({indice: 0, codIncidencia: valoresSeguimiento.codIncidencia})
                            }
                        }}
                    >
                        <i className='fa fa-plus'></i>
                    </button>
                </div>
            </Modal>
        </>
    )
}